<template>
  <b-modal id="editar-url-transparencia-modal" size="lg" centered header-bg-variant="secondary"
    header-text-variant="light" title="Alterar URL da Transparência" @hidden="$emit('fecharModal')"
    :no-close-on-esc="isLoading" :no-close-on-backdrop="isLoading" :hide-header-close="isLoading">
    <template v-slot:modal-footer="">
      <b-button @click="clickMe" :disabled="isLoading">
        <b-spinner small v-if="isLoading"></b-spinner>
        <span class="d-none d-md-inline ml-1 px-2">Salvar</span>
      </b-button>
    </template>
    <b-row>
      <b-col cols="12" lg="9">
        <div class="form-group">
          <label for="url-transparencia">URL</label>
          <b-form-input class="mb-2" id="url-transparencia" v-model="url">            
          </b-form-input>
        </div>
      </b-col>    
    </b-row>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import serigyService from "@/services/administracao/serigyService";
import { Ug } from "@/types/administracao/serigy/ug-serigy/ug";
import { PropType } from "vue/types/v3-component-props";

const CompProps = Vue.extend({
  name: "ModalEditUrlTransparencia",
  props: {
    item: {
      type: Object as PropType<Ug>,
      required: true,
    },
  },  
});

@Component
export default class ModalEditUrlTransparencia extends mixins(
  UtilsTS,
  CompProps,
) {
  isLoading = false
  url = this.item.urlTransparencia

  async clickMe(): Promise<void> {
    try {
      this.isLoading = true
      if (this.url === '') {
        this.$toast.error('Preencha o campo URL', { timeout: 1000 })
        return
      }
      try {
        new URL(this.url)
      } catch (error) {
        this.$toast.error('URL inválida', { timeout: 1000 })
        return
      }      
      const response = await serigyService.alterarUrlTansparencia(this.item.codUgSagres, this.url)
      this.$emit('alterarUrlTransparencia', response)
      this.$toast.success('URL da transparência alterado', { timeout: 1000 })
    } catch (e: unknown) {
      console.log('e', e)
      this.tratarError(e)
    } finally {
      this.isLoading = false
    }
  }


  async mounted(): Promise<void> {
    try {
      this.$bvModal.show("editar-url-transparencia-modal");
    } catch (e: unknown) {
      console.log('e', e)
      this.tratarError(e)
    }
  }
}
</script>
